import React, { useState } from 'react';
import PublicVoucherCard from '../components/PublicVoucherCard';
import { useVoucherLookup } from '../hooks/useVoucherLookup';

export default function VoucherLookupPage() {
  const [voucherCode, setVoucherCode] = useState('');
  const [phone, setPhone] = useState('');
  const { voucher, loading, error, lookupVoucher } = useVoucherLookup();

  function handleSubmit(event) {
    event.preventDefault();
    lookupVoucher({ voucherCode, phone });
  }

  return (
    <section className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-emerald-50 px-4 py-28">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-3">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-orange-500">Bonos Mundolandia</p>
          <h1 className="text-5xl font-black text-slate-900">Consulta tu bono</h1>
          <p className="text-slate-500 max-w-2xl mx-auto">
            Introduce tu número de bono o el número móvil asociado para ver horas disponibles, usos registrados y fecha de vencimiento.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-2xl p-8 grid md:grid-cols-[1fr_1fr_auto] gap-4">
          <input
            type="text"
            value={voucherCode}
            onChange={(event) => setVoucherCode(event.target.value)}
            placeholder="Número de bono"
            className="rounded-2xl border border-slate-300 px-5 py-4 text-lg font-semibold"
          />
          <input
            type="tel"
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
            placeholder="Número móvil"
            className="rounded-2xl border border-slate-300 px-5 py-4 text-lg font-semibold"
          />
          <button
            type="submit"
            disabled={loading}
            className="rounded-2xl bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 disabled:opacity-60"
          >
            {loading ? 'Buscando...' : 'Consultar'}
          </button>
        </form>

        <p className="text-center text-sm text-slate-400">
          Puedes consultar usando solo uno de los dos campos.
        </p>

        {error && <p className="text-center text-red-600 font-semibold">{error}</p>}
        {voucher && <PublicVoucherCard voucher={voucher} />}
      </div>
    </section>
  );
}
